import { render, staticRenderFns } from "./HomeSectionEmpty.vue?vue&type=template&id=5112a030"
import script from "./HomeSectionEmpty.vue?vue&type=script&lang=js"
export * from "./HomeSectionEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports